var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"move-pending"},[_c('img',{attrs:{"src":"/assets/images/icon_pending.svg","alt":""}}),_c('h3',[_vm._v(_vm._s(_vm.$t('digitalServices.move.pendingStatus.title')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }